module.exports = __webpack_public_path__ + "img/1-PISICNA.7a14ba82.webp";